import React, { useState } from 'react'
import { getUserId } from "../../../Utils/helper";
import { apiBaseURL } from '../../../Utils/ProjectConstants';
import './progressStyles.css'


const stepKeyPO = [
    { value: 0, text: 'New Request' },
    { value: 1, text: 'Supervisor Approved' },
    { value: 2, text: 'Business Manager Approved' },
    { value: 3, text: 'With Legal' },
    { value: 4, text: 'PO Entered' },
    { value: 5, text: 'PO Sent to Vendor' },
    { value: 7, text: 'Cancelled' },
    { value: 8, text: 'On Hold' },
   
];

const stepKeyOrders = [
    { value: 0, text: 'New Order' },
    { value: 1, text: 'Supervisor Approved' },
    { value: 2, text: 'PCard Approved' },
    { value: 3, text: 'On Hold' },
    { value: 4, text: 'Assistance Requested' },
    { value: 5, text: 'Assistance Approved' },
    { value: 6, text: 'Orederd' },
    { value: 7, text: 'Shipped' },
    { value: 8, text: 'Out for Delivery' },
    { value: 9, text: 'Delivered' },
    { value: 10, text: 'Denied' },
    { value: 11, text: 'Cancelled' },
    { value: 12, text: 'Out of stock' },
    { value: 13, text: 'Order Edited' },
   
];

const ProgressBar = ({ type, order, fetch, fetchSuccessful, mutate }) => {
    const status = type === 'PO' ? order.poStatus : order.status;
    const [currentStep, setStep] = useState(status)
    //const isUserKristen = true;
    const isUserKristen = getUserId() === "d4ec0560-d7b0-4385-81a3-ef5ac53df4da";

    const createArray = (length) => [...Array(length)];

    // moved onNext here, because both places are using the same function
    const onNext = async (status) => {
        let body = {}
        let response = null
        switch (type) {
            case 'PO':
                body = {
                    id: order.id,
                    userId: order.requestor?.id,
                    vendorName: order.vendorName,
                    vendorContact: order.vendorContact,
                    vendorEmail: order.vendorEmail,
                    vendorAddress: order.vendorAddress,
                    deadlineType: order.deadlineType,
                    deadlineDate: order.deadlineDate,
                    urgencyJustification: order.urgencyJustification,
                    POAdditionalEmails: order.poAdditionalEmails,
                    additionalInfo: order.additionalInfo,
                    shippingLocationId: order.shippingLocation.id,
                    shippingAttn: order.shippingAttn,
                    provideShippingAccountOnPO: order.provideShippingAccountOnPO,
                    purchaseType: order.purchaseType,
                    isInstallationRequired: order.isInstallationRequired,
                    installationRequirements: order.installationRequirements,
                    billingCode: order.billingCode,
                    otherBilling: order.otherBilling,
                    poStatus: status,
                }

                if (body.poStatus === 1) {
                    response = await fetch.post(`${apiBaseURL}/api/Approval/Approve/PurchaseOrder?purchaseOrderId=${body.id}`);
                } else {
                    response = await fetch.put(`${apiBaseURL}/api/PurchaseOrders`, body);
                }
                if (fetchSuccessful(response)) {
                    setStep(status)
                    mutate && mutate();
                }
                break;
            case 'Order':
                body = {
                    id: order.id,
                    vendors: order.vendors,
                    urgency: order.urgency,
                    status: status
                }

                if (body.status === 0) {
                    response = await fetch.post(`${apiBaseURL}/api/Approval/Approve?orderId=${body.id}`);
                } else {
                    response = await fetch.put(`${apiBaseURL}/api/Orders`, body);
                }
                if (fetchSuccessful(response)) {
                    setStep(status)
                    mutate && mutate();
                }
                break;
            default:
                break;
        }
    }

    function Step({ step, done, selected, currentStep }) {

        const validation = ((currentStep === 0 && step.value === 1) || (type === 'PO' && isUserKristen)) && !selected;

        const onStepClick = () => {
            if (validation) {
                return onNext(step.value);
            }
            return null;
        }

        return (
            <div
                className={`step ${done ? 'done' : ''} ${selected ? 'current' : ''}`}
                onClick={onStepClick}
                style={{ padding: step.value > 6  ? '10px' : null }}>
                <span
                    className={`${validation ? 'progressButton' : null}`}>
                    {step.text}
                </span>
            </div>
        )
    }

    function Steps({ current = 0 }) {
        const stepKey = type === 'PO' ? stepKeyPO : stepKeyOrders;
        if (current > 6) {
            return (
                <Step
                    key={0}
                    done={true}
                    selected={true}
                    step={stepKey.find(x => x.value === current)} />
            );
        }
        return createArray(6).map((n, i) => (
            <Step
                key={i}
                currentStep={currentStep}
                done={currentStep > i}
                selected={currentStep === i}
                step={stepKey.find(x => x.value === i)}
            />
        ));
    }

    return (
        <>
            <div className="arrow-steps center clearfix">
                <Steps current={currentStep} />
            </div>
        </>
    );
};

export default ProgressBar